module.exports = __webpack_public_path__ + "pic/43.b6399795.png";